import { CURRENT_USER, currentUser } from "../api/auth-request";
import { useQuery } from "@tanstack/react-query";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { setUser } from "../redux/slices/user-slice";
import { useEffect } from "react";

const fetchUser = async () => {
  const response = await currentUser();
  return response.data;
};

export const useCurrentUser = (loadUser?: boolean) => {
  const dispatch = useAppDispatch();
  const userDux = useAppSelector((state) => state.user.value);

  const { data, isLoading, isSuccess, isError, refetch } = useQuery({
    queryKey: [CURRENT_USER],
    queryFn: fetchUser,
    enabled: !!loadUser,
    refetchOnWindowFocus: false,
    retry: false,
  });

  useEffect(() => {
    if (loadUser) {
      if (isError) {
        dispatch(setUser(null));
      }
      if (isSuccess) {
        dispatch(setUser(data?.data));
      }
    }
  }, [data, dispatch, isError, isSuccess, loadUser]);

  return { user: userDux, loading: isLoading, loadUser: refetch };
};
